import React from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import UserSettings from "@Screens/UserSettings/UserSettings"
import { PasswordChangeForm } from "@Screens/UserSettings/MyAccount/PasswordChangeForm/PasswordChangeForm"
import { MyAccountForm } from "@Screens/UserSettings/MyAccount/Form/MyAccountForm"
import { Profile } from "@Screens/UserSettings/MyAccount/Form/Profile"
import { EmailAdress } from "@Screens/UserSettings/MyAccount/Form/EmailAddress"
import { FAQ } from "@Screens/UserSettings/MyAccount/FAQ/FAQ"
import BibliographySources from "@Screens/UserSettings/Bibliography/BibliographySources/BibliographySources"

const AccountStackNavigator = createNativeStackNavigator()
const MyAccountStack = () => {
    return (
        <AccountStackNavigator.Navigator
            screenOptions={{
                headerShown: false
            }}
            initialRouteName="UserSettingStack"
        >
            <AccountStackNavigator.Screen name="UserSettingStack" component={UserSettings} />
            <AccountStackNavigator.Screen name="MyAccountForm" component={MyAccountForm} />
            <AccountStackNavigator.Screen name="Profile" component={Profile} />
            <AccountStackNavigator.Screen name="Password" component={PasswordChangeForm} />
            <AccountStackNavigator.Screen name="EmailAdress" component={EmailAdress} />
            <AccountStackNavigator.Screen name="FAQ" component={FAQ} />
            <AccountStackNavigator.Screen name="BibliographySources" component={BibliographySources} />
        </AccountStackNavigator.Navigator>
    )
}

export default MyAccountStack
